exports.uploader_init = (o) => {


  var $ = jQuery;


  var $screenUpload_uploadCon = null; // -- step 1
  var $screenTrackOptions_mainOptions = null; // -- step 2
  const $areaDrop = $('.dzs-single-upload--areadrop');


  window.uploader_reinit = function () {

    if (window.dzsuploader_single_init) {
      //console.info('ceva', $('span:not(.for-clone-item) .dzs-single-upload'));
      window.dzsuploader_single_init('.dzs-single-upload', {
        action_file_uploaded: action_uploader_success,
        action_uploader_error: action_uploader_error,
        action_file_upload_start: action_uploader_startedUpload
      });
    }

    $screenUpload_uploadCon = $('.dzsapp--frontend-uploader--upload-track-con').eq(0);
    $screenTrackOptions_mainOptions = $('.main-upload-options-con').eq(0);

  }







  if (typeof $areaDrop.get(0) != 'undefined') {
    $areaDrop.get(0).addEventListener("drop", function (e) {
      $('.dzsapp-page-upload--mainuploader').removeClass('phase-one');
    }, false);
  }


  $('.dzsapp-page-upload--mainuploader input[type="submit"]').bind('click', function () {
    if ($('.dzsapp-page-upload--mainuploader').hasClass('type-video')) {
      if (String($('.dzsapp-page-upload--mainuploader input[name="dzsapp_featured_media"]').val()).indexOf('.mp4') == -1) {
        alert('Uploaded file  must be an mp4.')
        return false;
      }
    }
    if (String($('.dzsapp-page-upload--mainuploader input[name="video_title"]').val()) == '') {
      alert('You must set a title.')
      return false;
    }
  });



  window.uploader_reinit();


  $(document).on('change', '.submit-track-form select[name=type],.submit-track-form *[name=source]', handle_change);
  $(document).on('submit', 'form.submit-track-form', handle_change);
  $(document).on('click', '.cancel-upload-btn , .submit-track-form .btn-submit, .submit-track-form .single-submit-for-main-media', handle_click);


  $(document).on('click', '.dzsapp-page-upload--mainuploader .dzs-single-upload.drag-drop,.btn-upload-frontend, .dzsapp-button-submit-playlist', handle_mouse);


  function handle_mouse(e) {
    var _t = $(this);

    if (e.type === 'click') {
      if (_t.hasClass('drag-drop')) {
        console.info("drag and dropped");

        if (_t.prev().hasClass('dzs-single-upload')) {
          _t.prev().find('.btn_upl').trigger('click');
        }
      }
      if (_t.hasClass('dzsapp-button-submit-playlist')) {


        var data = {
          dzsapp_action: 'create_playlist'
          , postdata: $('.create-playlist-con').serialize()
        };


        $.ajax({
          type: "POST",
          url: o.settings_php_handler,
          data: data,
          success: function (response) {
            if (typeof window.console != "undefined") {
              console.log('Got this from the server: ' + response);
            }


            response = parse_response(response);
            show_notice(response);


            dzsapp_box_main_con.children('.overlay-background').trigger('click');

          },
          error: function (arg) {
            if (typeof window.console != "undefined") {
              console.log('Got this from the server: ' + arg, arg);
            }
            ;

          }
        });


        return false;
      }
      if (_t.hasClass('btn-upload-frontend')) {


        // console.info("CLICKED");
        var _targetInput = _t.prev();

        var uploader_frame = wp.media.frames.dzsapp_addplayer = wp.media({
          // Set the title of the modal.
          title: "Insert Media Modal",
          multiple: true,
          // Tell the modal to show only images.
          library: {
            type: 'video'
          },

          // Customize the submit button.
          button: {
            // Set the text of the button.
            text: "Insert Media",
            // Tell the button not to close the modal, since we're
            // going to refresh the page when the image is selected.
            close: false
          }
        });


        uploader_frame.on('select', function () {
          // Grab the selected attachment.
          var attachment = uploader_frame.state().get('selection').first();


          console.info(attachment.attributes, ' _targetInput - ', _targetInput);

          var arg = attachment.attributes.url;
          _targetInput.val(arg);
          _targetInput.trigger('change');
//            frame.close();

          uploader_frame.close();
        });

        uploader_frame.open();
      }
    }
  }


  function handle_click(e) {

    var _t = $(this);
    var _con = null;
    //console.info(_t);

    if (e.type === 'click') {


      if (_t.hasClass('cancel-upload-btn')) {
        // console.log('cancel-upload-btn event', e);

        cancel_submit(_t);


        return false;

      }
      if (_t.hasClass('btn-submit')) {
        //console.log('ceva');


        var _c = $('.id-upload-mp3').eq(0);
        upload_hide_upload_field(_c, {'call_from': 'btn-submit'});
        return false;
      }
      if (_t.hasClass('single-submit-for-main-media')) {
        //console.log('ceva');


        var _c = $('.id-upload-mp3').eq(0);
        upload_hide_upload_field(_c, {'call_from': 'submit_for_main_media'});
        return false;
      }


    }
  }


  function handle_change(e) {

    var _t = $(this);
    var _con = null;
    // console.info('change - ',_t);

    if (e.type == 'submit') {


      if (_t.hasClass('submit-track-form')) {

        console.info('trying to submit');


        if (String(_t.find('*[name=source]').eq(0).val()).trim() === '') {


          show_notice("success - Source field cannot be blank");
          return false;

        }

        if (String(_t.find('*[name=title]').eq(0).val()).trim() === '') {


          show_notice("success - Title field cannot be blank");
          return false;

        }

      }
    }
    if (e.type === 'change') {
      if (_t.attr('name') === 'is_buyable') {
        //console.info(_t, _t.prop('checked'));

        if (_t.prop('checked')) {

          $('.price-conglomerate').addClass('active');
        } else {
          // -- you can see typing is slow now ... lets see later...
          $('.price-conglomerate').removeClass('active');
        }
      }
      if (_t.attr('name') == 'thumbnail') {
        //console.info(_t, _t.prop('checked'));

        if (_t.val()) {
          if (_t.parent().find('.preview-thumb-con').length > 0) {
            var _cach = _t.parent().find('.preview-thumb-con').eq(0);

            _cach.addClass('has-image');
            _cach.css('background-image', 'url(' + _t.val() + ')');
          }
        }
      }
      if (_t.attr('name') == 'type') {
        //console.info(_t, _t.prop('checked'));

        if (_t.parent().parent().hasClass('submit-track-form')) {
          _con = _t.parent().parent();


          _con.removeClass('type-video type-youtube  type-vimeo type-soundcloud ');

          _con.addClass('type-' + _t.val());

          var uploader_type = _t.val();
          if (_t.val() == 'video') {
            //_con.find('.the-real-uploader').removeAttr('multiple');
          }

          if (_t.val() == 'youtube') {
            //_con.find('.the-real-uploader').attr('multiple', '');
          }
        }
      }
      if (_t.attr('name') == 'source') {
        var _con = null;


        if (_t.parent().parent().parent().hasClass('submit-track-form')) {
          _con = _t.parent().parent().parent();
        }
        if (_con.hasClass('type-youtube') || _con.hasClass('type-vimeo')) {
          // return false;
        }


        upload_hide_upload_field(_t, {'call_from': 'change source'});
      }
    }
  }


  function cancel_submit(_t) {


    $screenUpload_uploadCon.removeClass('disabling');


    // console.info('CANCEL SUBMIT');

    var _con = null;

    if (_t.parent().parent().parent().hasClass('submit-track-form')) {
      _con = _t.parent().parent().parent();
    }


    if (_con) {
      _con.removeClass('phase2');

    }

    $screenTrackOptions_mainOptions.removeClass('active');

    var _cach = _t.parent().parent();
    if (_cach.hasClass('parameters-con')) {

    }

  }

  function show_notice(response) {


    var _feedbacker = $('.feedbacker').eq(0);


    console.warn('_feedbacker - ', _feedbacker);

    if (typeof response == 'object') {
      if (response.report === 'success') {

        _feedbacker.removeClass('is-error');
        _feedbacker.addClass('active');
        _feedbacker.html(response.text);


        setTimeout(function () {

          _feedbacker.removeClass('active');
        }, 1500)
      }
      if (response.report == 'error') {

        _feedbacker.addClass('is-error');
        _feedbacker.html(response.text);
        _feedbacker.addClass('active');

        setTimeout(function () {

          _feedbacker.removeClass('active');
        }, 1500)
      }
    } else {
      if (response.indexOf('error -') == 0) {
        _feedbacker.addClass('is-error');
        _feedbacker.html(response.substr(7));
        // _feedbacker.fadeIn('fast');
        _feedbacker.addClass('active');

        setTimeout(function () {


          _feedbacker.removeClass('active');
        }, 1500)
      }
      if (response.indexOf('success -') == 0) {
        _feedbacker.removeClass('is-error');
        _feedbacker.html(response.substr(9));
        // _feedbacker.fadeIn('fast');

        _feedbacker.addClass('active');
        setTimeout(function () {



          _feedbacker.removeClass('active');
        }, 1500)
      }
    }


  }


  function action_uploader_error(uploadError) {

    $screenUpload_uploadCon.removeClass('uploader-is-loading');
    console.log('error when uploading', uploadError);
  }
  function action_uploader_startedUpload(pfile, pargs) {

    $screenUpload_uploadCon.addClass('uploader-is-loading');


    var uploader_type = 'audio';

    console.log('%c action_file_upload_start()', 'color: #cc00cc',' from PORTAL uploader_type ( ' + uploader_type + ' ) - ', pfile, ' pargs - ', pargs);


    var cthis = pargs.cthis;

    if (cthis && cthis.attr('data-uploader-type')) {
      uploader_type = cthis.attr('data-uploader-type');
    }

    const $mainUploadOptions = $('.main-upload-options');

    if (uploader_type === 'audio') {

      // console.warn("String(pfile.name).indexOf('.m4v') - ", String(pfile.name).indexOf('.m4v'));

      var verifyExtension = String(pfile.name).toLocaleLowerCase().substr(String(pfile.name).length - 5);

      if (verifyExtension.indexOf('.wav') > -1 || verifyExtension.indexOf('.ogg') > -1 || verifyExtension.indexOf('.mp3') > -1 || verifyExtension.indexOf('.m4a') > -1) {
        $mainUploadOptions.addClass('loader-active');
        window.dzs_uploader_force_progress($mainUploadOptions);
      } else {

        show_notice('error - ' + 'Only songs are allowed!')

        window.dzsuploader_stop = true;

      }
      let theFilename = String(pfile.name);
      theFilename = theFilename.replace('.mp3', '');
      theFilename = theFilename.replace('.ogg', '');
      theFilename = theFilename.replace('.wav', '');
      theFilename = theFilename.replace('.mp4', '');
      theFilename = theFilename.replace('.m4v', '');


      if (pargs.cthis.prev().hasClass('id-upload-mp3')) {

        $('*[name="title"]').val(theFilename);
      }
    }
    if (uploader_type == 'image') {
      var test_extension = String(pfile.name).toLocaleLowerCase().substr(String(pfile.name).length - 5);

      if (test_extension.indexOf('.jpg') > -1 || test_extension.indexOf('.jpeg') > -1 || test_extension.indexOf('.gif') > -1 || test_extension.indexOf('.png') > -1) {
        $mainUploadOptions.addClass('loader-active');
        window.dzs_uploader_force_progress($mainUploadOptions);
      } else {

        show_notice('error - ' + 'Only images are allowed!')

        window.dzsuploader_stop = true;

      }
      let theFilename = String(pfile.name);
      theFilename = theFilename.replace('.mp3', '');
      theFilename = theFilename.replace('.ogg', '');
      theFilename = theFilename.replace('.wav', '');
      theFilename = theFilename.replace('.mp4', '');
      theFilename = theFilename.replace('.m4v', '');


      if (pargs.cthis.prev().hasClass('id-upload-mp3')) {

        $('*[name="title"]').val(theFilename);
      }
    }

    if (uploader_type == 'album') {
      if (String(pfile.name).indexOf('.mp3') > -1) {


        var theFilename = String(pfile.name);
        theFilename = theFilename.replace('.mp3', '');

        $('*[name="title"]').val(theFilename);



        const $uploadTrackOptionsCon = $('.upload-track-options-con');
        $uploadTrackOptionsCon.append('<div class="upload-track-options"><input type="hidden" name="track_source[]"><div class="preloader-bar dzs-upload--progress--barprog"></div><div class="handle-con"><i class="fa fa-bars"></i></div><div class="input-con"><input type="text" name="track_title[]"> </div><div class="delete-track-con"><i class="fa fa-times"></i></div></div>');
        var _c = $uploadTrackOptionsCon.find('.upload-track-options').last();
        _c.addClass('loader-active');
        window.dzs_uploader_force_progress(_c);

        _c.find('input[name*="track_title"]').val(theFilename);
      }
    }




    //show_notice(arg);
    //


  }

  function uploaderChangeScreenTrackDetails(){
    upload_hide_upload_field($('input[name="source"]'), {'call_from': 'action_file_upload_start'});
    $screenTrackOptions_mainOptions.addClass('uploader--screen-track-details');


    const $trackDetailsContainer = $('.main-upload-options-con');

    // console.info('_C .main-upload-options - ',_c);
    init_tinymces($trackDetailsContainer);

    $screenTrackOptions_mainOptions.css('height', 'auto');

    var mainUploadOptionsHeight = ($screenTrackOptions_mainOptions.get(0).scrollHeight);


    $screenTrackOptions_mainOptions.css('height', '1px');

    setTimeout(function () {
      $trackDetailsContainer.animate({
        'height': mainUploadOptionsHeight
      }, {
        queue: false
        , duration: 300
        , complete: function () {
          $(this).css('height', 'auto');
        }
      });

      $trackDetailsContainer.addClass('main-option-active');
    }, 100);
    $trackDetailsContainer.addClass('main-option-active');
  }


  function action_uploader_success(argresp, pargs, matches) {
    $screenUpload_uploadCon.removeClass('uploader-is-loading');

    var uploader_type = 'video';
    console.info('action_file_uploaded from PORTAL', argresp, pargs);


    if (argresp.report === 'error') {
      show_notice(argresp);


      $('.cancel-upload-btn').eq(0).trigger('click');
    }


    // _c2.find('input[name*="track_source"]').eq(0).val(pargs.final_location);

    if (uploader_type == 'album') {

      var name = String(pargs.file.name);
      name = name.replace('.mp3', '');

      var _c = $('.upload-track-options-con').eq(0);
      _c.find('input[name*="track_title"]').each(function () {
        var _t2 = $(this);

        if (name == _t2.val()) {
          var _c2 = _t2.parent().parent();

          _c2.find('input[name*="track_source"]').eq(0).val(pargs.final_location);
        }

        //console.info('testing name', name, _t2.val());
      })
    }


    var _c = $('.main-upload-options').eq(0);
    _c.addClass('main-option-active');


    //show_notice(arg);
    //

    uploaderChangeScreenTrackDetails()
  }


  function init_tinymces(_con) {


    // console.info(_con);

    _con.find('.with-tinymce').each(function () {
      var _t = $(this);
      // console.info(_t);

      var _con = _t.parent().parent().parent().parent();


      var trackid = (_con.find('*[name=track_id]').eq(0).val());

      // console.warn(trackid);
      _t.attr('id', 'fortinymce' + trackid);
      init_try_tinymce(_t);
    })
  }

  function upload_hide_upload_field(arg, pargs) {


    var margs = {
      'call_from': 'default'
    }


    if (pargs) {
      margs = $.extend(margs, pargs);
    }


    var _t = arg;
    var $formSubmitTrack = null;
    var type = 'video';
    var _mainUploadOptionsCon = null;

    if (_t.parent().parent().parent().hasClass('submit-track-form')) {
      $formSubmitTrack = _t.parent().parent().parent();

    }

    var tval = '';

    if (_t.val) {
      tval = _t.val();
    }


    console.info('%cupload_hide_upload_field() - ', 'color: #00dddd;', arg, margs, ' new val - ', tval, ' _t  - ', _t, _t.prop('checked'), $formSubmitTrack);


    if ($formSubmitTrack) {
      var source = $formSubmitTrack.find('*[name=source]').eq(0).val();
      if (source) {
      } else {
        if ($formSubmitTrack.hasClass('type-youtube') || $formSubmitTrack.hasClass('type-vimeo')) {
          show_notice('error - ' + 'Input a id or link')
          return false;
        }
      }


      if ($formSubmitTrack.hasClass('type-youtube')) {
        type = 'youtube';
      }

      if ($formSubmitTrack.hasClass('type-vimeo')) {
        type = 'vimeo';
      }

      console.log('_mainUploadOptionsCon - ', $screenTrackOptions_mainOptions);

      // - subitting
      $screenTrackOptions_mainOptions.addClass('active');


      var ch = $screenTrackOptions_mainOptions.height();





      var _auxcon = $formSubmitTrack;
      setTimeout(function () {

        // console.info(_auxcon.find('.dzs-tabs').get(0));

        if (_auxcon.find('.dzs-tabs').get(0).api_handle_resize) {

          _auxcon.find('.dzs-tabs').get(0).api_handle_resize();
        }
      }, 50);
      setTimeout(function () {

        // console.info(_auxcon.find('.dzs-tabs').get(0));

        if (_auxcon.find('.dzs-tabs').get(0).api_handle_resize) {

          _auxcon.find('.dzs-tabs').get(0).api_handle_resize();
          _auxcon.find('.dzs-tabs').eq(0).find('.tab-content').eq(0).addClass('active');
        }
      }, 150);
      setTimeout(function () {

        _auxcon.addClass('phase2');
      }, 100);


      if (window.dzsapp_try_to_generate_image == 'on') {


        $('.dzs-single-upload-preview-img').addClass('generating-thumb');


        // source = _auxcon.find('*[name=source]').eq(0).val();


        if (type == 'video') {


          var aux43 = '<div class="screenshot-canvas-con';


          if (window.dzsapp_settings && window.dzsapp_settings.debug_mode == 'on') {
            aux43 += ' debug-mode';
          }


          aux43 += '"><video width="600" height="400" src="' + source + '"></video><canvas width="600" height="400"></canvas></div>';


          _auxcon.after(aux43);


          var _c = _auxcon.next();
          var canvas = _c.find('canvas').get(0);
          var ctx = canvas.getContext('2d');
          var video = _c.find('video').get(0);

          _c.find('video').get(0).currentTime = 5;


          setTimeout(function () {

            ctx.drawImage(video, 0, 0);


            var xhr = null;

            var canvasData = canvas.toDataURL("image/png");
            var xmlHttpReq = false;
            if (window.XMLHttpRequest) {
              xhr = new XMLHttpRequest();
            }

            xhr.open('POST', dzsapp_settings.dzsapp_site_url + '?dzsapp_action=savescreenshot&name=' + source, false);
            xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
            xhr.onreadystatechange = function () {
              // console.log(ajax.responseText);

              var response = xhr.responseText;

              if (xhr.readyState == 4 && xhr.status == 200) {

                _auxcon.find('*[name=thumbnail]').val(response);
                _auxcon.find('*[name=thumbnail]').trigger('change');
                _auxcon.find('.dzs-single-upload-preview-img').css('background-image', 'url(' + response + ')');
                $('.dzs-single-upload-preview-img').removeClass('generating-thumb');

                $('.screenshot-canvas-con:not(.debug-mode)').remove();

              }
            }
            xhr.send("imgData=" + canvasData);

          }, 4500);

        }


        if (type == 'youtube') {


          if (source.indexOf('youtube.com') > -1) {
            source = get_query_arg(source, 'v');
          } else {

          }


          var response = 'https://img.youtube.com/vi/' + source + '/0.jpg';
          // $thumb = "";

          _auxcon.find('*[name=thumbnail]').val(response);
          _auxcon.find('*[name=thumbnail]').trigger('change');
          _auxcon.find('.dzs-single-upload-preview-img').css('background-image', 'url(' + response + ')');
          $('.dzs-single-upload-preview-img').removeClass('generating-thumb');


        }
        if (type == 'vimeo') {

          source = source.replace('https://vimeo.com/', '');
          var data = {
            action: 'nothing'
          };


          $.ajax({
            type: "POST",
            url: dzsapp_settings.dzsapp_site_url + '?dzsapp_action=get_vimeo_thumb&vimeo_id=' + source,
            data: data,
            success: function (response) {
              if (typeof window.console != "undefined") {
                console.log('Got this from the server: ' + response);
              }

              var _auxcon = $(document);

              console.info("_con.find('*[name=thumbnail]') - ", $formSubmitTrack.find('*[name=thumbnail]'));
              _auxcon.find('*[name=thumbnail]').val(response);
              _auxcon.find('*[name=thumbnail]').trigger('change');
              _auxcon.find('.dzs-single-upload-preview-img').css('background-image', 'url(' + response + ')');
              $('.dzs-single-upload-preview-img').removeClass('generating-thumb');

            }
          })
        }

      }


    }

    if (_t.parent().hasClass('dzs-upload-con')) {


      $screenUpload_uploadCon.addClass('disabling');


    }

    return true;
  }


  function init_try_tinymce(_c) {

    if (_c.hasClass('tinymce-activated')) {
      return false;
    }

    if (window.tinyMCE) {


      // console.info("HMM trying to init tinymce");
      tinyMCE.baseURL = window.dzsapp_plugin_url + 'libs/tinymce';
      tinyMCE.init({
        selector: '#' + _c.attr('id')
        , base: window.dzsapp_plugin_url + 'libs/tinymce/'
        , menubar: false
        , toolbar: 'styleselect | bold italic | link image code bullist numlist'
        , plugins: 'code,lists,link,textcolor,wordcount'
        , selection_toolbar: 'bold italic | quicklink h2 h3 blockquote code fontsize '
      });

      _c.addClass('tinymce-activated');


    } else {

      if (window.tinymce_trying_to_load !== true) {

        window.tinymce_trying_to_load = true;

        $.getScript(window.dzsapp_plugin_url + 'libs/tinymce/tinymce.min.js', function (data, textStatus, jqxhr) {

          init_try_tinymce(_c);
        })
      }
    }
  }

}